<template>
<div ref="select" class="pub-nav-select">
  <span ref="head" class="head-text" @click="showMenu=true">{{text}}<i class="el-icon-caret-bottom"></i></span>
  <div class="pub-nav-select-menu" v-show="showMenu">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'PubNavSelect',

  data () {
    return {
      showMenu: false
    }
  },

  props: {
    value: {},
    text: {}
  },

  methods: {
    documentClick (e) {
      let s = this.$refs.head
      let t = e.target
      if (!s.contains(t) && s !== t) {
        this.showMenu = false
      }
    },

    selectClick (e) {
//      console.log(`Received click: ${e.detail}`)
//      console.log(e)
      this.$emit('input', e.detail)
      e.stopPropagation()
    }
  },

  mounted () {
    this.$refs.select.addEventListener('select', this.selectClick)
    document.addEventListener('click', this.documentClick)
  },

  destroyed () {
    this.$refs.select.removeEventListener('select', this.selectClick)
    document.removeEventListener('click', this.documentClick)
  }
}
</script>

<style lang="scss" scoped>

.pub-nav-select {
  display: inline;
  position: relative;
  margin-left: 5px;
}

.pub-nav-select-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  width: width;
  padding: 0px;
}

.head-text {
  cursor: pointer;
  font-size: 10px;
  color: grey;
}

.head-text:hover {
  text-decoration: underline;
}

</style>
